/**
 * The concurrent-login "here's what happens next" message — the SINGLE source of the exact copy
 * (Account Sync Workflow spec 4.A), shared by the app-wide modal (`CqgConnectedPopup`) and the
 * connector dialog's inline notice (`ConcurrentNoticeView`) so the wording can never drift between
 * them. Both callers render their own "Setting up your concurrent login" heading; this renders the
 * three body paragraphs verbatim.
 */
export function CqgConnectedMessage() {
  return (
    <div className="flex flex-col gap-3 text-[13px] leading-5 text-text-muted">
      <p>
        To let you run your trading platform and the journal at the same time, we&apos;re setting up a
        concurrent login for your account. This can take up to <b className="text-text">48 hours</b>,
        and we&apos;ll notify you the moment it is ready.
      </p>
      <p>
        <b className="text-text">In the meantime:</b> You can start using the journal right away, but
        until your concurrent login is active, you can only be signed into one at a time.{' '}
        <b className="text-text">
          Syncing the journal and/or opening the journal will sign you out of your CQG trading platform.
        </b>
      </p>
      <p>Once setup is complete, you&apos;ll be able to use both together.</p>
    </div>
  );
}
